module.exports = __webpack_public_path__ + "img/21-1.09d59866.png";